import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "capitalization" }
const _hoisted_2 = {
  key: 0,
  class: "text-default text-message"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle mr5" }, null, -1)
const _hoisted_4 = {
  key: 1,
  class: "text-default text-message"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle mr5" }, null, -1)
const _hoisted_6 = {
  class: "flex",
  style: {"justify-content":"end"}
}

export function render(_ctx, _cache) {
  const _component_c_button = _resolveComponent("c-button")

  return (_ctx.isActive)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onKeydown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
        class: "modal-container"
      }, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.overLayClick && _ctx.overLayClick(...args))),
          class: "overlay"
        }),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.modalSize)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass([_ctx.headerClass, "modal-header"])
          }, [
            _renderSlot(_ctx.$slots, "title", {}, () => [
              _createElementVNode("b", _hoisted_1, _toDisplayString(_ctx.$t(_ctx.labelText)), 1)
            ]),
            _createElementVNode("i", {
              onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.onClose && _ctx.onClose(...args))),
              class: "fa fa-times go-right p3 pointer"
            })
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass([_ctx.contentClass, "modal-body"])
          }, [
            (_ctx.message)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _hoisted_3,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.message)), 1)
                ]))
              : (!_ctx.isText && !_ctx.custom)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _hoisted_5,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.text)), 1)
                  ]))
                : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "modal", { row: _ctx.payloads })
          ], 2),
          (_ctx.isAction)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([_ctx.footerClass, "modal-footer txt-right"])
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _renderSlot(_ctx.$slots, "action", { row: _ctx.actions }),
                  (_ctx.cancel)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.onClose && _ctx.onClose(...args))),
                        class: "btn btn-secondary capitalization pl15 pr15 btn-padding btn-default-setting"
                      }, _toDisplayString(_ctx.$t(_ctx.cancel)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.confirm)
                    ? (_openBlock(), _createBlock(_component_c_button, {
                        key: 1,
                        onHandler: _ctx.onConfirm,
                        isLoading: _ctx.isLoading,
                        class: "btn btn-primary ml6 capitalization pl15 pr15 btn-padding btn-keypress",
                        value: _ctx.confirm,
                        type: "span"
                      }, null, 8, ["onHandler", "isLoading", "value"]))
                    : _createCommentVNode("", true)
                ])
              ], 2))
            : _createCommentVNode("", true)
        ], 2)
      ], 32))
    : _createCommentVNode("", true)
}